import { createListenerMiddleware } from '@reduxjs/toolkit';
import { setSentryUser, setSentryPageContext } from '@/utils/sentry';
import { setUser, clearUser } from '../user/slice';
import { fetchUser } from '../user/thunks';
import { fetchPageById, updatePageById, publishPage } from '../pages/thunks';

// Create the listener middleware instance
export const sentryListenerMiddleware = createListenerMiddleware();

// Listen for user-related actions
sentryListenerMiddleware.startListening({
  actionCreator: setUser,
  effect: (action) => {
    setSentryUser(action.payload);
  },
});

sentryListenerMiddleware.startListening({
  actionCreator: clearUser,
  effect: () => {
    setSentryUser(null);
  },
});

sentryListenerMiddleware.startListening({
  actionCreator: fetchUser.fulfilled,
  effect: (action) => {
    setSentryUser(action.payload);
  },
});

// Listen for page-related actions
sentryListenerMiddleware.startListening({
  actionCreator: fetchPageById.fulfilled,
  effect: (action) => {
    setSentryPageContext(action.payload.id, action.payload.name);
  },
});

sentryListenerMiddleware.startListening({
  actionCreator: updatePageById.fulfilled,
  effect: (action) => {
    setSentryPageContext(action.payload.id, action.payload.name);
  },
});

sentryListenerMiddleware.startListening({
  actionCreator: publishPage.fulfilled,
  effect: (action) => {
    setSentryPageContext(action.payload.page.id, action.payload.page.name);
  },
});
